// extracted by mini-css-extract-plugin
module.exports = {"link":"Anchor_link__3hwOU","net":"Anchor_net__3op8Z"};